export const languageIcons: { [code: string]: string } = {
  it: 'assets/icons/language/it.png',
  en: 'assets/icons/language/en.png',
}
